import { Lock } from "lucide-react";
import { Link } from "react-router-dom";
import { useEntitlements } from "@/hooks/useEntitlements";
import { enforcementApplies } from "@/lib/entitlements";

// Funzioni "solo interfaccia" (es. la vista Calendario): se il piano NON le include E l'applicazione vale per questa attività si mostra il lucchetto
// al posto della pagina. I DATI restano sempre accessibili altrove (Prenotazioni). In ogni altro caso (caricamento, errore, Legacy, applicazione
// spenta) si mostra la pagina normale: mai nascondere qualcosa per un nostro errore.
export default function PlanGate({ feature, children }) {
  const { available, data } = useEntitlements();
  const f = available && enforcementApplies(data) ? data.features.find((x) => x.key === feature) : null;
  if (!f || !f.locked) return children;
  const req = f.lock?.required_plan;
  return (
    <div className="mx-auto max-w-xl p-6 md:p-10" data-testid={`plan-gate-${feature}`}>
      <div className="rounded-2xl border border-amber-300/70 bg-amber-50 p-6 text-amber-900 dark:border-amber-800/60 dark:bg-amber-950/30 dark:text-amber-200">
        <p className="flex items-center gap-2 text-lg font-bold"><Lock className="h-5 w-5" /> {f.label}</p>
        <p className="mt-2 text-sm">{f.lock?.message}</p>
        <p className="mt-2 text-xs opacity-80">Le tue prenotazioni restano sempre consultabili dalla pagina «Prenotazioni».</p>
        <div className="mt-4 flex flex-wrap gap-2">
          <Link to="/dashboard/assistenza" state={{ upgradeFor: feature, requiredPlan: req?.slug || null }} className="rounded-full border border-amber-400/70 bg-white/70 px-4 py-2 text-xs font-bold hover:bg-white dark:bg-card/60" data-testid={`plan-gate-upgrade-${feature}`}>
            {req ? `Richiedi il piano ${req.name}` : "Contatta l'assistenza"}
          </Link>
          <Link to="/dashboard/prenotazioni" className="rounded-full border border-border px-4 py-2 text-xs font-bold hover:bg-muted">Vai alle prenotazioni</Link>
        </div>
      </div>
    </div>
  );
}
